import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { WINDOW } from '@sentry/browser';
import { getNumberOfUrlSegments, logger } from '@sentry/utils';
import hoistNonReactStatics from 'hoist-non-react-statics';
import React__default from 'react';
var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; // Inspired from Donnie McNeal's solution:

var activeTransaction;
var _useEffect;
var _useLocation;
var _useNavigationType;
var _createRoutesFromChildren;
var _matchRoutes;
var _customStartTransaction;
var _startTransactionOnLocationChange;
var SENTRY_TAGS = {
  'routing.instrumentation': 'react-router-v6'
};
function reactRouterV6Instrumentation(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes) {
  return function (customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var initPathName = WINDOW && WINDOW.location && WINDOW.location.pathname;
    if (startTransactionOnPageLoad && initPathName) {
      activeTransaction = customStartTransaction({
        name: initPathName,
        op: 'pageload',
        tags: SENTRY_TAGS,
        metadata: {
          source: 'url'
        }
      });
    }
    _useEffect = useEffect;
    _useLocation = useLocation;
    _useNavigationType = useNavigationType;
    _matchRoutes = matchRoutes;
    _createRoutesFromChildren = createRoutesFromChildren;
    _customStartTransaction = customStartTransaction;
    _startTransactionOnLocationChange = startTransactionOnLocationChange;
  };
}
function getNormalizedName(routes, location, branches) {
  if (!routes || routes.length === 0) {
    return [location.pathname, 'url'];
  }
  var pathBuilder = '';
  if (branches) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var x = 0; x < branches.length; x++) {
      var branch = branches[x];
      var route = branch.route;
      if (route) {
        // Early return if index route
        if (route.index) {
          return [branch.pathname, 'route'];
        }
        var path = route.path;
        if (path) {
          var newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : "/".concat(path);
          pathBuilder += newPath;
          if (branch.pathname === location.pathname) {
            if (
            // If the route defined on the element is something like
            // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
            // We should check against the branch.pathname for the number of / seperators
            getNumberOfUrlSegments(pathBuilder) !== getNumberOfUrlSegments(branch.pathname) &&
            // We should not count wildcard operators in the url segments calculation
            pathBuilder.slice(-2) !== '/*') {
              return [newPath, 'route'];
            }
            return [pathBuilder, 'route'];
          }
        }
      }
    }
  }
  return [location.pathname, 'url'];
}
function updatePageloadTransaction(location, routes, matches) {
  var branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location);
  if (activeTransaction && branches) {
    var _activeTransaction;
    (_activeTransaction = activeTransaction).setName.apply(_activeTransaction, _toConsumableArray(getNormalizedName(routes, location, branches)));
  }
}
function handleNavigation(location, routes, navigationType, isBaseLocation, matches) {
  if (isBaseLocation) {
    if (activeTransaction) {
      activeTransaction.finish();
    }
    return;
  }
  var branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location);
  if (_startTransactionOnLocationChange && (navigationType === 'PUSH' || navigationType === 'POP') && branches) {
    if (activeTransaction) {
      activeTransaction.finish();
    }
    var _getNormalizedName = getNormalizedName(routes, location, branches),
      _getNormalizedName2 = _slicedToArray(_getNormalizedName, 2),
      name = _getNormalizedName2[0],
      source = _getNormalizedName2[1];
    activeTransaction = _customStartTransaction({
      name: name,
      op: 'navigation',
      tags: SENTRY_TAGS,
      metadata: {
        source: source
      }
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(Routes) {
  var _this = this;
  if (!_useEffect || !_useLocation || !_useNavigationType || !_createRoutesFromChildren || !_matchRoutes || !_customStartTransaction) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.\n      useEffect: ".concat(_useEffect, ". useLocation: ").concat(_useLocation, ". useNavigationType: ").concat(_useNavigationType, ".\n      createRoutesFromChildren: ").concat(_createRoutesFromChildren, ". matchRoutes: ").concat(_matchRoutes, ". customStartTransaction: ").concat(_customStartTransaction, "."));
    return Routes;
  }
  var isBaseLocation = false;
  var routes;
  var SentryRoutes = function SentryRoutes(props) {
    var location = _useLocation();
    var navigationType = _useNavigationType();
    _useEffect(function () {
      // Performance concern:
      // This is repeated when <Routes /> is rendered.
      routes = _createRoutesFromChildren(props.children);
      isBaseLocation = true;
      updatePageloadTransaction(location, routes);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.children]);
    _useEffect(function () {
      handleNavigation(location, routes, navigationType, isBaseLocation);
    }, [props.children, location, navigationType, isBaseLocation]);
    isBaseLocation = false;

    // @ts-ignore Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return React__default.createElement(Routes, _objectSpread(_objectSpread({}, props), {}, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 207
      }
    }));
  };
  hoistNonReactStatics(SentryRoutes, Routes);

  // @ts-ignore Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params
  return SentryRoutes;
}
function wrapUseRoutes(origUseRoutes) {
  var _this2 = this;
  if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes || !_customStartTransaction) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.');
    return origUseRoutes;
  }
  var isBaseLocation = false;

  // eslint-disable-next-line react/display-name
  return function (routes, location) {
    var SentryRoutes = function SentryRoutes(props) {
      var Routes = origUseRoutes(routes, location);
      var locationArgObject = typeof location === 'string' ? {
        pathname: location
      } : location;
      var locationObject = locationArgObject || _useLocation();
      var navigationType = _useNavigationType();
      _useEffect(function () {
        isBaseLocation = true;
        updatePageloadTransaction(locationObject, routes);
      }, [props]);
      _useEffect(function () {
        handleNavigation(locationObject, routes, navigationType, isBaseLocation);
      }, [props, locationObject, navigationType, isBaseLocation]);
      isBaseLocation = false;
      return Routes;
    };
    return React__default.createElement(SentryRoutes, {
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253
      }
    });
  };
}
function wrapCreateBrowserRouter(createRouterFunction) {
  // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (routes, opts) {
    var router = createRouterFunction(routes, opts);

    // The initial load ends when `createBrowserRouter` is called.
    // This is the earliest convenient time to update the transaction name.
    // Callbacks to `router.subscribe` are not called for the initial load.
    if (router.state.historyAction === 'POP' && activeTransaction) {
      updatePageloadTransaction(router.state.location, routes);
    }
    router.subscribe(function (state) {
      var location = state.location;
      if (_startTransactionOnLocationChange && (state.historyAction === 'PUSH' || state.historyAction === 'POP') && activeTransaction) {
        handleNavigation(location, routes, state.historyAction, false);
      }
    });
    return router;
  };
}
export { reactRouterV6Instrumentation, withSentryReactRouterV6Routing, wrapCreateBrowserRouter, wrapUseRoutes };